export default __webpack_public_path__ + "static/media/pool_icon.80c4511b.svg";